import * as Sentry from '@sentry/browser'
import {BrowserTracing} from '@sentry/tracing'
import {Config} from '../../config.js'

Sentry.init({
	environment     : Config.environment,
	dsn             : Config.sentry.dsn,
	tracesSampleRate: Config.sentry.sample_rate,
	integrations    : [new BrowserTracing()],
})

require('../../style/vendor/tailwind.css')

window.$ = window.jQuery = require('jquery')

require('@splidejs/splide/dist/css/splide.min.css')
require('@splidejs/splide/dist/js/splide.min.js')

require('animate.css/animate.min.css')

require('daterangepicker/daterangepicker.css')
require('daterangepicker/daterangepicker.js')

require('es6-promise/auto.js')

require('izitoast/dist/css/iziToast.min.css')
require('izitoast/dist/js/iziToast.min.js')

require('jquery.autokana/jquery.autoKana.js')

require('lazyload/lazyload.min.js')

require('picturefill/dist/picturefill.min')

require('pretty-checkbox/dist/pretty-checkbox.min.css')

require('remodal/dist/remodal.css')
require('remodal/dist/remodal-default-theme.css')
require('remodal/dist/remodal.min.js')

require('../../style/vendor/*.styl')

window.App = {
	_common : require('./client/_common.js').default,
	Cart    : require('./client/cart.js').default,
	Checkout: require('./client/checkout.js').default,
	Contact : require('./client/contact.js').default,
	My      : require('./client/my.js').default,
	Product : require('./client/product.js').default,
	Register: require('./client/register.js').default,

	common: {
		Date   : require('../../client/date.js').default,
		Form   : require('../../client/form.js').default,
		Helper : require('../../client/helper.js').default,
		Image  : require('../../client/image.js').default,
		Is     : require('../../client/is.js').default,
		Log    : require('../../client/log.js').default,
		Network: require('../../client/network.js').default,
		Table  : require('../../client/table.js').default,
		Toast  : require('../../client/toast.js').default,
		Ui     : require('../../client/ui.js').default,
	},
}
